export function getCookie(name) {
	const nameEQ = name + '=';
	const cookies = document.cookie.split(';');
	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i];
		while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
		if (cookie.indexOf(nameEQ) === 0)
			return cookie.substring(nameEQ.length, cookie.length);
	}
	return null;
}

export function setCookie(name, value, seconds) {
	// Calculate the expiration date
	const expires = new Date();
	expires.setTime(expires.getTime() + seconds * 1000); // Convert seconds to milliseconds

	// Format the expiration date as a GMT string
	const expiresString = expires.toUTCString();

	// Set the cookie with name, value, and expiration date
	document.cookie = `${name}=${value};expires=${expiresString};path=/`;
}

export function deleteCookie(name) {
	// Set the cookie's expiration date to a past date
	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}
